import { Component, OnInit } from '@angular/core';
import { AboutService } from './about.service';
import { catchError, map } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { of } from 'rxjs';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
  seoDes: string = 'ศูนย์จิตวิทยาพัฒนาการและความสัมพันธ์ระหว่างวัย (Psychology Center for Life-Span Development and Intergeneration) ได้รับทุนจากโครงการสร้างเสริมพลังจุฬาฯ ก้าวสู่ศตวรรษที่ 2 โดยมีวัตถุประสงค์หลักของโครงการมี 2 ข้อ ดังนี้';
  directorList;

  constructor(
    private aboutService: AboutService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.aboutService.about().pipe(
      map(res => {
        // // console.log(res.result);
        this.directorList = res.result;
        this.gobalFunctionService.setSEO('เกี่ยวกับเรา', 'website', this.seoDes);
      }),
      catchError((err) => {
        alert(err.error.message);
        return of(false);
      })
    ).subscribe();
  }
}
